import { openDB } from 'idb';

import { StorageAdapter } from './storage-adapter';

export class IndexedDBStorageAdapter implements StorageAdapter {
	private readonly DB_NAME = 'video-storage';
	private readonly STORE_NAME = 'videos';
	private readonly VIDEO_KEY = 'recorded-video';
	private readonly POSTER_KEY = 'video-poster';

	private async openDatabase() {
		return openDB(this.DB_NAME, 1, {
			upgrade(db) {
				db.createObjectStore('videos');
			},
		});
	}

	async save(file: File, type: 'video' | 'poster'): Promise<void> {
		const db = await this.openDatabase();
		const tx = db.transaction(this.STORE_NAME, 'readwrite');
		const key = type === 'video' ? this.VIDEO_KEY : this.POSTER_KEY;

		const blob = new Blob([file], { type: file.type });
		await tx.objectStore(this.STORE_NAME).put(blob, key);
		await tx.done;
	}

	async load(type: 'video' | 'poster'): Promise<File | null> {
		const db = await this.openDatabase();
		const key = type === 'video' ? this.VIDEO_KEY : this.POSTER_KEY;
		const blob = await db.transaction(this.STORE_NAME).objectStore(this.STORE_NAME).get(key);

		if (blob) {
			const fileName = type === 'video' ? 'recorded-video.webm' : 'video-poster.jpg';
			return new File([blob], fileName, { type: blob.type });
		}
		return null;
	}

	async delete(): Promise<void> {
		const db = await this.openDatabase();
		const tx = db.transaction(this.STORE_NAME, 'readwrite');
		await tx.objectStore(this.STORE_NAME).delete(this.VIDEO_KEY);
		await tx.objectStore(this.STORE_NAME).delete(this.POSTER_KEY);
		await tx.done;
	}
}
